type EventTarget = Window | Document | HTMLElement;
type EventCallback = (event: Event) => void;

class EventManager {
  /**
   * 複数のイベントリスナーを一度に登録する
   * @param target イベントを登録する対象（document, window, または HTMLElement）
   * @param eventTypes イベントタイプの配列
   * @param callback イベントハンドラー
   * @param options イベントリスナーのオプション
   */
  static addEventListeners(
    target: EventTarget,
    eventTypes: string[],
    callback: EventCallback,
    options?: AddEventListenerOptions
  ): void {
    eventTypes.forEach(eventType => {
      target.addEventListener(eventType, callback, options);
    });
  }

  /**
   * 複数のイベントリスナーを一度に削除する
   * @param target イベントを削除する対象（document, window, または HTMLElement）
   * @param eventTypes イベントタイプの配列
   * @param callback イベントハンドラー
   * @param options イベントリスナーのオプション
   */
  static removeEventListeners(
    target: EventTarget,
    eventTypes: string[],
    callback: EventCallback,
    options?: EventListenerOptions
  ): void {
    eventTypes.forEach(eventType => {
      target.removeEventListener(eventType, callback, options);
    });
  }

  /**
   * 一度だけ実行される複数のイベントリスナーを登録する
   * @param target イベントを登録する対象（document, window, または HTMLElement）
   * @param eventTypes イベントタイプの配列
   * @param callback イベントハンドラー
   * @param options イベントリスナーのオプション（{ once: true }が自動的に設定されます）
   */
  static addOneTimeEventListeners(
    target: EventTarget,
    eventTypes: string[],
    callback: EventCallback,
    options?: AddEventListenerOptions
  ): void {
    this.addEventListeners(target, eventTypes, callback, { ...options, once: true });
  }
}

export default EventManager;